'use client'

import { useEffect } from 'react'
import { GTMEvents } from '@/lib/GTMEvents'

/**
 * Fires the `homepage_view` funnel event once when the homepage mounts.
 * Rendered from the (server) homepage so the event works for both
 * traditional navigation and SPA route changes back to home.
 */
export default function HomepageViewTracker() {
    useEffect(() => {
        GTMEvents.homepageView()
    }, [])

    return null
}
